<div class="main-content-coantainer container-fluid whats-new-page">
  <div class="row">
    <div class="col-12">
      <h4 class="block-title">What's New</h4>
    </div>
  </div>

  <div class="row whats-new-layout">
    <div class="col-lg-2 col-md-3 col-12">
      <div class="date-list-card">
        <div class="list-title">Dates</div>
        <div *ngIf="loading" class="loading-text">Loading...</div>
        <div *ngIf="!loading && (!dates || dates.length === 0)" class="empty-text">
          No updates yet.
        </div>
        <ul class="list-unstyled date-list" *ngIf="!loading && dates?.length">
          <li
            *ngFor="let dateItem of dates"
            class="date-list-item"
            [ngClass]="{ active: selectedDate?.publish_date === dateItem.publish_date }"
            (click)="selectDate(dateItem)"
          >
            <span class="date-text">
              {{ dateItem.publish_date ? (dateItem.publish_date | date: "mediumDate") : "Unknown date" }}
            </span>
            <span *ngIf="dateItem.unread" class="unread-dot"></span>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-lg-10 col-md-9 col-12">
      <div class="entry-list-card" *ngIf="selectedDate; else emptyRight">
        <div class="list-title">
          {{ selectedDate.publish_date ? (selectedDate.publish_date | date: "fullDate") : "Updates" }}
        </div>
        <div *ngIf="!selectedDate.entries?.length" class="empty-text">
          No entries for this date.
        </div>
        <div class="entry-list" *ngIf="selectedDate.entries?.length">
          <div
            class="entry-item"
            *ngFor="let entry of selectedDate.entries"
            (click)="openEntry(entry)"
          >
            <div class="entry-header">
              <div class="entry-title-row">
                <span *ngIf="entry.is_unread" class="unread-dot"></span>
                <span class="entry-title">{{ entry.heading }}</span>
              </div>
              <span *ngIf="entry.tag" class="entry-tag" [ngClass]="tagClass(entry.tag)">{{ entry.tag }}</span>
            </div>
            <div class="entry-body" [innerHTML]="formatBody(entry.body_text) | safeHtml"></div>
            <div class="entry-links" *ngIf="entry.link_url">
              <a
                class="entry-btn"
                [href]="entry.link_url"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ entry.button_text || 'Open Link' }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <ng-template #emptyRight>
        <div class="entry-list-card">
          <div class="empty-text">Select a date to view updates.</div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
